import React from 'react';
import ListagemContato from '../ListagemContato';
import {
    Header,
    Body
} from '../../presentations';

function ListagemContatoPage() {
    return (
        <>
            <Header titulo='Fale com a gente'
                link='/' />
            <Body>
                <ListagemContato />
            </Body>
        </>
    );
}

export default ListagemContatoPage;